export const FLOOR_10_DATA = [
  {
    id: 'C057-1',
    status: 'available',
    floor: 10,
    building: 'A',
    apartmentNumber: 'C057-1',
    sceneName: 'scene_10krs_C057-1',
    sceneName_future: 'scene_10krs_C057-1_future',
    name: 'C057-1',
    label: 'C57-1',
    lookAt: '-215.35, 0, 120',
    face: 'south',
    area: {
      className: 'cls-12',
      points:
        '240 65.4167 242.9634 98.1044 280.0702 94.8181 275.3559 43.25 240 43.25 240 65.4167',
    },
    viewCone: {
      className: 'cls-1',
      pathData:
        'm262.9567,85.3264c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '260.2791',
      cy: '80.8798',
      circleClassName: 'cls-7',
    },
    namePaths: [
      {
        className: 'cls-4',
        d: 'm254.9424,57.3369c-.46.2236-1.0605.334-1.8018.334-.9668,0-1.7275-.2832-2.2803-.8516-.5547-.5684-.8311-1.3262-.8311-2.2725,0-1.0078.3115-1.8252.9336-2.4521.623-.627,1.4307-.9404,2.4238-.9404.6152,0,1.1338.0781,1.5557.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0693.1865-1.4326.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5146,1.4561.3418.3623.8037.543,1.3838.543.5537,0,1.0605-.1348,1.5205-.4043v1.2959Z',
      },
      {
        className: 'cls-4',
        d: 'm256.041,57.3994v-1.1875c.4307.2637.8887.3965,1.375.3965.3662,0,.6533-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3232-.9365-.2871,0-.6348.0273-1.042.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3584-.0273.5225-.0273.6475,0,1.1543.1709,1.5205.5098.3662.3408.5488.7979.5488,1.3711,0,.6367-.2178,1.1553-.6543,1.5586-.4365.4023-1.0283.6035-1.7754.6035-.6064,0-1.1162-.0908-1.5293-.2715Z',
      },
      {
        className: 'cls-4',
        d: 'm265.3047,51.9014l-2.2236,5.6602h-1.4678l2.2412-5.168h-2.9355v-1.1338h4.3857v.6416Z',
      },
    ],

    relatedApartments: {
      2: 'D060',
      3: 'D062',
      4: 'D065',
      5: 'D068',
      6: 'D071',
      7: 'D074',
      8: 'D077-1',
      9: 'D076-1',
    },
  },
  {
    id: 'C057-2',
    status: 'available',
    floor: 10,
    building: 'A',
    apartmentNumber: 'C057-2',
    sceneName: 'scene_10krs_C057-2',
    sceneName_future: 'scene_10krs_C057-2_future',
    name: 'C057-2',
    label: 'C57-2',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-12',
      points:
        '206.8333 39.9167 240 39.9167 240 65.4167 206.8333 65.3958 206.8333 39.9167',
    },
    viewCone: {
      className: 'cls-9',
      pathData:
        'm225.4688,56.52c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '222.7912',
      cy: '52.0734',
      circleClassName: 'cls-7',
    },
    namePaths: [
      {
        className: 'cls-11',
        d: '',
      },
      {
        className: 'cls-11',
        d: '',
      },
      {
        className: 'cls-11',
        d: '',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A007',
      4: 'B012',
      5: 'A016',
      6: 'B024-1',
      7: 'B026',
      8: 'C054-1',
      9: 'C058',
    },
  },
  {
    id: 'C056',
    status: 'available',
    floor: 10,
    building: 'A',
    apartmentNumber: 'C056',
    sceneName: 'scene_10krs_C056',
    sceneName_future: 'scene_10krs_C056_future',
    name: 'C056',
    label: 'C56',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-12',
      points:
        '272.7292 14.4226 275.3559 43.25 240 43.25 240 39.9167 206.8333 39.9167 206.8333 14.4375 272.7292 14.4226',
    },
    viewCone: {
      className: 'cls-10',
      pathData:
        'm225.4688,31.798c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '222.7912',
      cy: '27.3514',
      circleClassName: 'cls-7',
    },
    namePaths: [
      {
        className: 'cls-4',
        d: 'm254.9424,31.7334c-.46.2236-1.0605.334-1.8018.334-.9668,0-1.7275-.2832-2.2803-.8516-.5547-.5684-.8311-1.3262-.8311-2.2725,0-1.0078.3115-1.8252.9336-2.4521.623-.627,1.4307-.9404,2.4238-.9404.6152,0,1.1338.0781,1.5557.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0693.1865-1.4326.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5146,1.4561.3418.3623.8037.543,1.3838.543.5537,0,1.0605-.1348,1.5205-.4043v1.2959Z',
      },
      {
        className: 'cls-4',
        d: 'm256.041,31.7959v-1.1875c.4307.2637.8887.3965,1.375.3965.3662,0,.6533-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3232-.9365-.2871,0-.6348.0273-1.042.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3584-.0273.5225-.0273.6475,0,1.1543.1709,1.5205.5098.3662.3408.5488.7979.5488,1.3711,0,.6367-.2178,1.1553-.6543,1.5586-.4365.4023-1.0283.6035-1.7754.6035-.6064,0-1.1162-.0908-1.5293-.2715Z',
      },
      {
        className: 'cls-4',
        d: 'm264.9268,25.7217v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7432-.668,1.3232-.668.5273,0,.9453.1787,1.2539.5361.3096.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7695-2.6133.5117-.6514,1.208-.9775,2.0869-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A007',
      4: 'B012',
      5: 'A016',
      6: 'B024-1',
      7: 'B026',
      8: 'C054-1',
      9: 'C058',
    },
  },
]
